module.exports = __webpack_public_path__ + "img/reviews-img-3-test.bf9aa060.jpg";